export const ProjectData=[
  

    {
        id:1,
        title:"About Me",
        about: "  Muhammad Idrees Khan (محمد ادریس خان) Business Development | Freelancer | Front End developer | WordPress Developer | HTML5 | CSS3 | JavaScript | Bootstrap | React/Redux | NodeJs",
        tags:["ReactJS", "HTML", "SCSS", "JavaScript" , "AI Esport"],
        demo:"https://github.com/muhammadidreeskhan",
        github:"https://github.com/muhammadidreeskhan",
        image:"https://avatars.githubusercontent.com/u/82828412?v=4",
    },
];